export const BRUSH_SIZES = [2, 4, 6, 8, 12, 18, 26, 38, 52, 70] as const;
export const brushIndexForWidth = (width: number) => {
  let closest = 0; let distance = Infinity;
  BRUSH_SIZES.forEach((value, index) => { const next = Math.abs(value - width); if (next < distance) { closest = index; distance = next; } });
  return closest;
};
export const brushWidthForRatio = (ratio: number) => Math.round(1 + Math.max(0, Math.min(1, ratio)) * 69);
